import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
  IconButton
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { AiFillCloseCircle } from 'react-icons/ai';
import Loading from '../Loading';
import StyledRoundIconButton from '../Styled/styledRoundIconButton';

const dialogPosition = {
  'top-center': {
    top: 32,
  },
};

const StyledDialog = styled(Dialog)(({ theme, position }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2, 3),
  },
  '& .MuiDialog-paper:not(.MuiDialog-paperFullScreen)': position !== 'auto' && {
    position: 'fixed',
    maxHeight: 'calc(100vh - 128px - 100vh * 0.1)',
    ...dialogPosition[position],
  },
}));

function Popup(props) {
  const {
    title,
    fullScreenBreakpoint = 'md',
    children,
    open,
    onClose,
    loading = false,
    disableCloseButton = false,
    position = 'top-center',
    fullWidth = false,
    ...rest
  } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(
    theme.breakpoints.down(fullScreenBreakpoint)
  );

  return (
    <StyledDialog
      fullScreen={fullScreen}
      open={open}
      scroll="paper"
      fullWidth={fullWidth}
      {...rest}>
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap={1}>
          <Typography variant="h6" noWrap>
            {title}
          </Typography>
          {!disableCloseButton && (
            <StyledRoundIconButton onClick={() => onClose()}>
              <IoCloseSharp />
            </StyledRoundIconButton>
          )}
        </Stack>
      </DialogTitle>

      <Divider variant="middle" />

      {loading ? (
        <DialogContent sx={{ minHeight: 400 }}>
          <Loading />
        </DialogContent>
      ) : (
        children
      )}
    </StyledDialog>
  );
}

Popup.propTypes = {
  title: PropTypes.string.isRequired,
  fullScreenBreakpoint: PropTypes.string,
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  position: PropTypes.oneOf(['top-center', 'auto']),
  onClose: PropTypes.func.isRequired,
  disableCloseButton: PropTypes.bool,
};

export default Popup;
